import { render, staticRenderFns } from "./UsuarioVendas.vue?vue&type=template&id=fcbc8b6c&scoped=true&"
import script from "./UsuarioVendas.vue?vue&type=script&lang=js&"
export * from "./UsuarioVendas.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioVendas.vue?vue&type=style&index=0&id=fcbc8b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbc8b6c",
  null
  
)

export default component.exports